// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iAMjGrpoB39VgnvLjdtJ {
  width: 320px;
  height: 300px;
  padding: 20px;
  box-shadow: 1px 2px 7px 1px #bbb;
  border-radius: 8px;
  position: relative;
  margin-top: 5px;
  margin-left: 10px;
  display: inline-block;
}
.pl_G0hDAnKQK_uiGjoHi {
  background-color: #fff;
  width: 100%;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
}
.CUAVOoFhsXk1BEYWku8l {
  position: absolute;
  right: 5px;
  top: 5px;
}
.BbI9jNr7kW2n0LHiIywq {
  max-height: 150px;
  max-width: 100%;
  margin: 0 auto;
  display: block;
}
.XO2x3RxbW09dp9RQTWjv {
  font-size: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  max-height: 3em;
  line-height: 1.5em;
}
.i6Sr9zHc23BIUeERHT6b {
  border-color: #1677ff !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Workspace/FlowSheetCard/index.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AACF;AAEA;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;AAAF;AAGA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AADF;AAIA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAFF;AAKA;EACE,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAHF;AAMA;EACE,gCAAA;AAJF","sourcesContent":[".container {\n  width: 320px;\n  height: 300px;\n  padding: 20px;\n  box-shadow: 1px 2px 7px 1px #bbb;\n  border-radius: 8px;\n  position: relative;\n  margin-top: 5px;\n  margin-left: 10px;\n  display: inline-block;\n}\n\n.flowSheets {\n  background-color: #fff;\n  width: 100%;\n  padding: 20px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 20px;\n}\n\n.cardActions {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n}\n\n.cardImg {\n  max-height: 150px;\n  max-width: 100%;\n  margin: 0 auto;\n  display: block;\n}\n\n.cardDescription {\n  font-size: 18px;\n  display: -webkit-box; \n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  max-height: 3em;\n  line-height: 1.5em;\n}\n\n.active {\n  border-color: #1677ff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `iAMjGrpoB39VgnvLjdtJ`,
	"flowSheets": `pl_G0hDAnKQK_uiGjoHi`,
	"cardActions": `CUAVOoFhsXk1BEYWku8l`,
	"cardImg": `BbI9jNr7kW2n0LHiIywq`,
	"cardDescription": `XO2x3RxbW09dp9RQTWjv`,
	"active": `i6Sr9zHc23BIUeERHT6b`
};
export default ___CSS_LOADER_EXPORT___;
